import React, { useContext, useEffect, useState } from 'react';
import { LangContext } from '../../contexts/langContext';
import { SocialContext } from '../../contexts/socialContext';
import { StateContext } from '../../contexts/stateContext';
import {
  getArrow,
  getDesignNodeTone,
  getDesignSunTone,
  getPersNodeTone,
  getPersSunTone,
  getTone
} from '../utilsDesign';
import { AstroIcon } from './AstroIcon';
import { colors, theme } from './Colors';
import { TooltipH } from './TooltipH';





export const BodyArrows = React.memo(({
  hints,
  theme = {
    designColor: theme.designColor,
    personalityColor: theme.personalityColor,
  },
  design = {},
  variables = {
    left_up: "right",
    left_down: "left",
    right_up: "left",
    right_down: "left",
  },
  arrowsB1,
  arrowsB2,
  arrowsP1,
  arrowsP2,
  bodygraphWidth = 90,
  size = 'md',

}) => {

  const context = { ...useContext(SocialContext), ...useContext(StateContext), ...useContext(LangContext) };
  const $vars = context.$vars;

  bodygraphWidth = bodygraphWidth !== 0 ? bodygraphWidth : 90;
  // console.log('bodygraphWidth = ', bodygraphWidth !== 90 && bodygraphWidth);

  const [width, setWidth] = useState(bodygraphWidth)

  const sizes = {
    'sm': 14,
    'md': 26,
    'lg': 44,
    'xlg': 54,
  }

  useEffect(() => {
    if (bodygraphWidth !== width) setWidth(bodygraphWidth)
  }, [bodygraphWidth])

  const calculateSize = (width) => {

    const originalParentWidth = 600;
    const originalSize = sizes[(width && width > 120) ? 'md' : 'xlg'];

    const scaleFactor = (width && width < originalParentWidth) ? width / originalParentWidth * 1.2 : 1;
    // const scaleFactor = 1;
    // console.log('scaleFactor = ', scaleFactor);
    const newSize = Math.floor(originalSize * scaleFactor);
    return newSize;
  };



  const leftArrows = [
    { variable: 'diet', show: arrowsB1 },
    { variable: 'env', show: arrowsB2 },
  ].filter(({ show }) => show !== false);

  const rightArrows = [
    { variable: 'motivation', show: arrowsP1 },
    { variable: 'perspective', show: arrowsP2 },
  ].filter(({ show }) => show !== false);

  if (!leftArrows.length && !rightArrows.length) {
    return null;
  }

  return (
    <>

      <div className={`x_bodygraph_arrows ${hints ? 'x_bodygraph_arrows--blur' : ''}`}>

        {Boolean(leftArrows.length) && <div className="x_bodygraph_arrows_1"
          style={{ fontSize: calculateSize(width / 2) }}
        >

          {leftArrows.map(({ variable }) => (
            <BodyArrowNew
              key={variable}
              prs={false}
              arrow={getTone[variable](design, true)}
              width={calculateSize(width)}
              height={calculateSize(width)}
              tooltip={`${$vars(`${getArrow[variable]}_${getTone[variable](design, true)}`, 'title')} ${$vars(getArrow[variable])}`}
            />
          ))}

        </div>}

        {Boolean(rightArrows.length) && <div className="x_bodygraph_arrows_1"
          style={{ fontSize: calculateSize(width / 2) }}
        >

          {rightArrows.map(({ variable }) => (
            <BodyArrowNew
              key={variable}
              prs={true}
              arrow={getTone[variable](design, true)}
              width={calculateSize(width)}
              height={calculateSize(width)}
              tooltip={`${$vars(`${getArrow[variable]}_${getTone[variable](design, true)}`, 'title')} ${$vars(getArrow[variable])}`}
            />
          ))}

        </div>}



        {/* <div className="x_bodygraph_arrows_1"
          style={{ fontSize: calculateSize(width / 2) }}
        >
          {arrowsB1 && Boolean(design.design && design.design.length) && <div className="x_bodygraph_arrow">
            {variables['left_up'] === 'right' && <Svg
              color={theme.designColor}
              width={calculateSize(width)}
              height={calculateSize(width)}
            >
              {arrowBR}
            </Svg>}
            {variables['left_up'] === 'left' && <Svg
              color={theme.designColor}
              width={calculateSize(width)}
              height={calculateSize(width)}
            >
              {arrowBL}
            </Svg>}

          </div>}

          {arrowsB2 && Boolean(design.design && design.design.length) && <div className="x_bodygraph_arrow">

            {variables['left_down'] === 'right' && <Svg
              color={theme.designColor}
              width={calculateSize(width)}
              height={calculateSize(width)}
            >
              {arrowBR}
            </Svg>}

            {variables['left_down'] === 'left' && <Svg
              color={theme.designColor}
              width={calculateSize(width)}
              height={calculateSize(width)}
            >
              {arrowBL}
            </Svg>}

          </div>}
        </div> */}

        {/* <div className="x_bodygraph_arrows_1"
          style={{ fontSize: calculateSize(width / 2) }}
        >
          {arrowsP1 && Boolean(design.personality.length) && <div className="x_bodygraph_arrow"
            style={{ margin: `${calculateSize(width) / 4} 0` }}
          >
            {variables['right_up'] === 'right' && <Svg
              color={theme.personalityColor}
              width={calculateSize(width)}
              height={calculateSize(width)}
            >
              {arrowPR}
            </Svg>}
            {variables['right_up'] === 'left' && <Svg
              color={theme.personalityColor}
              width={calculateSize(width)}
              height={calculateSize(width)}
            >
              {arrowPL}
            </Svg>}
          </div>}
          {arrowsP2 && Boolean(design.personality.length) && <div className="x_bodygraph_arrow">
            {variables['right_down'] === 'right' && <Svg
              color={theme.personalityColor}
              width={calculateSize(width)}
              height={calculateSize(width)}
            >
              {arrowPR}
            </Svg>}
            {variables['right_down'] === 'left' && <Svg
              color={theme.personalityColor}
              width={calculateSize(width)}
              height={calculateSize(width)}
            >
              {arrowPL}
            </Svg>}
          </div>}
        </div> */}
      </div>

    </>
  )
})




export const BodyArrow = React.memo(({
  className,
  design,
  variables = {
    left_up: "right",
    left_down: "left",
    right_up: "left",
    right_down: "left",
  },
  arrowsB1,
  arrowsB2,
  arrowsP1,
  arrowsP2,
  prs = false,
  title,
  description,
  size = 'md',
  tooltip = true
}) => {


  const context = { ...useContext(LangContext), ...useContext(StateContext) };
  const $vars = context.$vars;
  const palette = colors[context.state.colorMode]?.base;

  const sizes = {
    'xs': 18,
    'sm': 22,
    'md': 26,
    'lg': 44,
    'xlg': 64,
  }

  const renderArrow = (direction, isPrs) => (
    <AstroIcon
      name={direction === 'right' ? 'arrow-right' : 'arrow-left'}
      className={className}
      size={sizes[size]}
      color={isPrs ? palette?.prs : palette?.des}
    />
  );


  return (
    <>

      {arrowsB1 && <>

        <TooltipH
          mobileOff
          title={`${$vars(`left_up_${getDesignSunTone(design, true)}`, 'title')} ${$vars(`label_diet`)}`}
        >
          {renderArrow(variables['left_up'], false)}
        </TooltipH>
      </>}

      {arrowsB2 && <>

        <TooltipH 
          mobileOff
          title={`${$vars(`left_down_${getDesignNodeTone(design, true)}`, 'title')} ${$vars(`label_env`)}`}>
          {renderArrow(variables['left_down'], false)}
        </TooltipH>

      </>}



      {arrowsP1 && <>

        <TooltipH 
          mobileOff
          title={`${$vars(`right_up_${getPersSunTone(design, true)}`, 'title')} ${$vars(`label_motivation`)}`}>
          {renderArrow(variables['right_up'], true)}
        </TooltipH>
      </>}

      {arrowsP2 && <>

        <TooltipH 
          mobileOff
          title={`${$vars(`right_down_${getPersNodeTone(design, true)}`, 'title')} ${$vars(`label_perspective`)}`}>
          {renderArrow(variables['right_down'], true)}
        </TooltipH>
      </>}



    </>
  )
})





export const BodyArrowNew = React.memo(({
  tooltip = '',
  arrow = 'left',
  size = 'md',
  prs,
  width,
  height,
}) => {


  const context = { ...useContext(LangContext), ...useContext(StateContext) };
  const $vars = context.$vars;

  const sizes = {
    'xs': 18,
    'sm': 22,
    'md': 26,
    'lg': 44,
    'xlg': 64,
  }


  return (
    <>


      <TooltipH 
        mobileOff
        title={tooltip} overlayClassName='inact'>

        <AstroIcon
          name={arrow === 'right' ? 'arrow-right' : 'arrow-left'}
          width={width ? width : sizes[size]}
          height={height ? height : sizes[size]}
          color={prs ? colors[context.state.colorMode]['base'].prs : colors[context.state.colorMode]['base'].des}
        />

      </TooltipH>



    </>
  )
})